import React from 'react';
import { Outlet } from 'react-router-dom';

type Props = {};

const DatabasePageLayout = (props: Props) => {
    return (
        <><Outlet /></>
    );
};

export default DatabasePageLayout;